import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import CallbackForm from './components/CallbackForm';
import Footer from './components/Footer';
import FloatingContact from './components/FloatingContact';
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from 'sonner';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-white">
        <Header />
        <Hero />
        <Services />
        <CallbackForm />
        <Footer />
        <FloatingContact />
        <Toaster position="top-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;